import {Determinant} from "./determinant";

export class RegistrationDeterminant extends Determinant {

  public determinantType = "REGISTRATION";
  public registrationId: string;
  public selected = true;

}
